
export const Groups = {
    LOADING_GROUPS_LIST: "LOADING_GROUPS_LIST",
    GET_GROUPS_LIST: "GET_GROUPS_LIST",
  };

